import React from 'react';
import { motion } from 'framer-motion';

const Message = ({ message, index = 0 }) => {
  const renderMessageWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline font-medium"
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  const isUser = message.type === 'user';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}
    >
      <div className={`max-w-[85%] rounded-2xl p-4 ${
        isUser 
          ? 'bg-gradient-to-br from-primary to-primary-hover text-white rounded-br-sm' 
          : 'bg-gray-100 text-gray-800 border border-gray-200 rounded-bl-sm'
      }`}>
        {message.image && (
          <div className="mb-2 rounded-lg overflow-hidden">
            <img src={message.image} alt="Uploaded" className="max-w-full max-h-96 object-cover" />
          </div>
        )}
        {message.text && (
          <div className="text-base leading-relaxed">
            {message.type === 'bot' ? (
              renderMessageWithLinks(message.text)
            ) : (
              message.text
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default Message;

